import "./page/collage"
import "./page/headings"
import "./page/highlights"
import "./page/reel"
import "./page/cloud"
import "./page/scrollIndicator"

import { Experience } from "./experience"
import { MainNav } from "./page/mainNav"
import { Sections } from "./page/sections"

const experience = new Experience("ThreeScreen")
const nav = new MainNav()
const sections = new Sections()

function setCurrentChapter() {
    const currentSection = sections.currentSection

    if (currentSection != -1) {
        nav.highlightChapter(currentSection)
        experience.setCurrentChapter(currentSection)
    }
}

window.addEventListener("scroll", setCurrentChapter, { passive: true })
